export class CheckboxEvent
{
	public static BEFORE_CHANGE: string = "component:checkbox:before_change";
	public static AFTER_CHANGE : string = "component:checkbox:after_change";
}
